/**
 * Controller for AppManager
 */
define('controllers/mysetting/teamaccount/member.account.detail.ctrl',['app'], function (app) {
    app.controller('MemberAccountDetailCtrl', ['$q', '$scope', '$location', '$timeout','$stateParams', '$state', 'auiDialog', 'auiTeamAccountService', 'UserInfoPreload', 'OpenUp', '$rootScope','auiAgreementHelper',
        function ($q, $scope, $location, $timeout,$stateParams, $state, auiDialog, auiTeamAccountService, UserInfoPreload, OpenUp, $rootScope,auiAgreementHelper) {
            var Model = $scope.Model = {};
            $scope.cancel = cancel;
            //成员帐号的自己详情取消
            $scope.cancelDetail = cancelDetail;
            //成员帐号的自己详情确认
            $scope.submit = submit;
            $scope.setAcceptMessage = setAcceptMessage;
            $scope.quitTeam = quitTeam;

            // 展示语种，传给aui展示
            $scope.notifyMsgLangList = sysParamCfg.displaylangCountries;

            Model.isMemberDetail = ($location.url().split('/')[2] =='memberDetail');

            Model.isMemberAccountDetail = ($location.url().split('/')[2] =='memberAccountDetail') && ($location.url().split('/')[1] =='mysetting');

            // 是否展示通知消息语种
            Model.showMsgLang = true;
            Model.fakeMemberID = $stateParams.fakeMemberID;
            $rootScope.checkState($state);

            //取消
            function cancel() {
                $state.go("mysetting.teamAccountInfoList", {reload: true});
            }
            //成员帐号的自己详情取消
            function cancelDetail() {
                $state.go('mysetting.memberDetail', {}, {reload: true});
            }

            //成员帐号的自己详情确认
            function submit() {
                if(($scope.addAccountForm.memberEmail.$dirty && ($scope.addAccountForm.memberEmail.$error.pattern ||$scope.addAccountForm.memberEmail.$error.required)) ||
                	($scope.addAccountForm.memberNickName.$dirty && $scope.addAccountForm.memberNickName.$error.required) ||  !Model.teamMemberInfo.memberNickName ||
                    !AUI.BaseJSUtil.isNikeName(Model.teamMemberInfo.memberNickName) ||
                    (Model.memberEmailOld == Model.teamMemberInfo.memberEmail &&
                    Model.acceptMessageOld ==Model.teamMemberInfo.acceptMessage &&
                    Model.acceptMarketMsgOld == Model.teamMemberInfo.acceptMarketMsg &&
                    Model.memberNickNameOld == Model.teamMemberInfo.memberNickName &&
                    Model.memberMsgLang == Model.teamMemberInfo.memberMsgLang )) return;
                var req = {};
                if(Model.acceptMessageOld != Model.teamMemberInfo.acceptMessage) req.acceptMessage = Model.teamMemberInfo.acceptMessage;
                if(Model.acceptMarketMsgOld != Model.teamMemberInfo.acceptMarketMsg) req.acceptMarketMsg = Model.teamMemberInfo.acceptMarketMsg;
                if(Model.memberEmailOld != Model.teamMemberInfo.memberEmail) req.memberEmail = Model.teamMemberInfo.memberEmail;
                if(Model.memberNickNameOld != Model.teamMemberInfo.memberNickName) req.memberNickName = Model.teamMemberInfo.memberNickName;
                if(Model.memberMsgLangOld != Model.teamMemberInfo.memberMsgLang) req.memberMsgLang = Model.teamMemberInfo.memberMsgLang;
                OpenUp.updateInfoByMember({req: req}).then(function () {
                    auiDialog.success("提交成功",function () {
                        cancelDetail();
                    });
                });
            }

            function setAcceptMessage(type, acceptType) {
                    Model.teamMemberInfo[acceptType == 1 ? 'acceptMessage' : 'acceptMarketMsg'] = type == 1 ? 2 : 1;
            }

            function quitTeam() {
                auiDialog.confirm("退出团队", "是否确认退出该团队？<br/>退出后您将无法使用该团队帐号进行开发、分发、推广、变现等操作。", function () {
                    auiTeamAccountService.quitTeam().then(function (data) {
                        if (data) {
                            //为了再进来的设置
                            sessionStorage.setItem("x-uid", UserInfoPreload.userRouteInfo.currentUserRouteInfo.memberUserID);
                            if(sysUrlCfg.oAuthConfig.isSetXUid){
                                AUI.HDGWCall.setCookie("x-uid", UserInfoPreload.userRouteInfo.currentUserRouteInfo.memberUserID)
                            }
                            AUI.HDGWCall.delUserInfoKey("teamid");
                            if (AUI.HDGWCall.getCookieOrSessionSt("siteid-member")) {
                                AUI.HDGWCall.setUserInfoValue("siteid", AUI.HDGWCall.getCookieOrSessionSt("siteid-member"));
                                window.sessionStorage.removeItem("siteid-member");
                            }
                            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.indexUrl);
                        }
                    });
                });
            }
            Model.downLoadAgreement = function () {
                auiAgreementHelper.viewAndDownloadAgreements([1053]);
            };


        }]);
});

